import { ref as C, shallowRef as m, computed as o, watch as p, onMounted as F, onBeforeUnmount as x, toRef as B, createVNode as w, mergeProps as H, watchEffect as L } from "vue";
import { p as V, at as N, aP as U, cy as $, $ as I, g as R, r as M, cz as O, a1 as W, a2 as A, u as z, cm as k, W as Y, d as q, h as Q, l as j, n as D, o as G, s as J, Q as K, Y as X, x as Z, A as _, au as ee, a4 as te } from "./VTextarea-a9029832.mjs";
const ae = V({
  scrollTarget: {
    type: String
  },
  scrollThreshold: {
    type: [String, Number],
    default: 300
  }
}, "scroll");
function le(e) {
  let f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    canScroll: u
  } = f;
  let c = 0;
  const s = C(null), t = m(0), i = m(0), n = m(0), h = m(!1), v = m(!1), r = o(() => Number(e.scrollThreshold)), g = o(() => N((r.value - t.value) / r.value || 0)), d = () => {
    const a = s.value;
    !a || u && !u.value || (c = t.value, t.value = "window" in a ? a.pageYOffset : a.scrollTop, v.value = t.value < c, n.value = Math.abs(t.value - r.value));
  };
  return p(v, () => {
    i.value = i.value || t.value;
  }), p(h, () => {
    i.value = 0;
  }), F(() => {
    p(() => e.scrollTarget, (a) => {
      var b;
      const S = a ? document.querySelector(a) : window;
      if (!S) {
        U(`Unable to locate element with identifier ${a}`);
        return;
      }
      S !== s.value && ((b = s.value) == null || b.removeEventListener("scroll", d), s.value = S, s.value.addEventListener("scroll", d, {
        passive: !0
      }));
    }, {
      immediate: !0
    });
  }), x(() => {
    var a;
    (a = s.value) == null || a.removeEventListener("scroll", d);
  }), u && p(u, d, {
    immediate: !0
  }), {
    scrollThreshold: r,
    currentScroll: t,
    currentThreshold: n,
    isScrollActive: h,
    scrollRatio: g,
    // required only for testing
    // probably can be removed
    // later (2 chars chlng)
    isScrollingUp: v,
    savedScroll: i
  };
}
const oe = V({
  scrollBehavior: String,
  modelValue: {
    type: Boolean,
    default: !0
  },
  location: {
    type: String,
    default: "top",
    validator: (e) => ["top", "bottom"].includes(e)
  },
  ...$(),
  ...I(),
  ...ae(),
  height: {
    type: [Number, String],
    default: 64
  }
}, "VAppBar"), ue = R()({
  name: "VAppBar",
  props: oe(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, f) {
    let {
      slots: u
    } = f;
    const c = C(), s = M(e, "modelValue"), t = o(() => {
      var y;
      const l = new Set(((y = e.scrollBehavior) == null ? void 0 : y.split(" ")) ?? []);
      return {
        hide: l.has("hide"),
        // fullyHide: behavior.has('fully-hide'),
        inverted: l.has("inverted"),
        collapse: l.has("collapse"),
        elevate: l.has("elevate"),
        fadeImage: l.has("fade-image")
        // shrink: behavior.has('shrink'),
      };
    }), i = o(() => {
      const l = t.value;
      return l.hide || // behavior.fullyHide ||
      l.inverted || l.collapse || l.elevate || l.fadeImage || // behavior.shrink ||
      !s.value;
    }), {
      currentScroll: n,
      scrollThreshold: h,
      isScrollingUp: v,
      scrollRatio: r
    } = le(e, {
      canScroll: i
    }), g = o(() => e.collapse || t.value.collapse && (t.value.inverted ? r.value > 0 : r.value === 0)), d = o(() => e.flat || t.value.elevate && (t.value.inverted ? n.value > 0 : n.value === 0)), a = o(() => t.value.fadeImage ? t.value.inverted ? 1 - r.value : r.value : void 0), S = o(() => {
      var P, T;
      if (t.value.hide && t.value.inverted)
        return 0;
      const l = ((P = c.value) == null ? void 0 : P.contentHeight) ?? 0, y = ((T = c.value) == null ? void 0 : T.extensionHeight) ?? 0;
      return l + y;
    });
    O(o(() => !!e.scrollBehavior), () => {
      L(() => {
        t.value.hide ? t.value.inverted ? s.value = n.value > h.value : s.value = v.value || n.value < h.value : s.value = !0;
      });
    });
    const {
      ssrBootStyles: b
    } = W(), {
      layoutItemStyles: E
    } = A({
      id: e.name,
      order: o(() => parseInt(e.order, 10)),
      position: B(e, "location"),
      layoutSize: S,
      elementSize: m(void 0),
      active: s,
      absolute: B(e, "absolute")
    });
    return z(() => {
      const l = k.filterProps(e);
      return w(k, H({
        ref: c,
        class: ["v-app-bar", {
          "v-app-bar--bottom": e.location === "bottom"
        }, e.class],
        style: [{
          ...E.value,
          "--v-toolbar-image-opacity": a.value,
          height: void 0,
          ...b.value
        }, e.style]
      }, l, {
        collapse: g.value,
        flat: d.value
      }), u);
    }), {};
  }
});
const se = V({
  app: Boolean,
  color: String,
  height: {
    type: [Number, String],
    default: "auto"
  },
  ...Y(),
  ...q(),
  ...Q(),
  ...I(),
  ...j(),
  ...D({
    tag: "footer"
  }),
  ...G()
}, "VFooter"), ce = R()({
  name: "VFooter",
  props: se(),
  setup(e, f) {
    let {
      slots: u
    } = f;
    const {
      themeClasses: c
    } = J(e), {
      backgroundColorClasses: s,
      backgroundColorStyles: t
    } = K(B(e, "color")), {
      borderClasses: i
    } = X(e), {
      elevationClasses: n
    } = Z(e), {
      roundedClasses: h
    } = _(e), v = m(32), {
      resizeRef: r
    } = ee((a) => {
      a.length && (v.value = a[0].target.clientHeight);
    }), g = o(() => e.height === "auto" ? v.value : parseInt(e.height, 10)), {
      layoutItemStyles: d
    } = A({
      id: e.name,
      order: o(() => parseInt(e.order, 10)),
      position: o(() => "bottom"),
      layoutSize: g,
      elementSize: o(() => e.height === "auto" ? void 0 : g.value),
      active: o(() => e.app),
      absolute: B(e, "absolute")
    });
    return z(() => w(e.tag, {
      ref: r,
      class: ["v-footer", c.value, s.value, i.value, n.value, h.value, e.class],
      style: [t.value, e.app ? d.value : {
        height: te(e.height)
      }, e.style]
    }, u)), {};
  }
});
export {
  ue as V,
  ce as a
};
